module.exports = __webpack_public_path__ + "img/work-slide-04-small.661e7b77.jpg";